/**
 * This file ensures there's only one version of React in the application
 * and properly binds all React hooks to that instance.
 */

import React from 'react';

// Bind hooks to React to prevent "Cannot read properties of null" errors
const originalUseState = React.useState;
const originalUseEffect = React.useEffect;
const originalUseContext = React.useContext;
const originalUseReducer = React.useReducer;
const originalUseCallback = React.useCallback;
const originalUseMemo = React.useMemo;
const originalUseRef = React.useRef;

// Create properly bound versions of hooks
React.useState = function(...args) {
  return originalUseState.apply(React, args);
};

React.useEffect = function(...args) {
  return originalUseEffect.apply(React, args);
};

React.useContext = function(...args) {
  return originalUseContext.apply(React, args);
};

React.useReducer = function(...args) {
  return originalUseReducer.apply(React, args);
};

React.useCallback = function(...args) {
  return originalUseCallback.apply(React, args);
};

React.useMemo = function(...args) {
  return originalUseMemo.apply(React, args);
};

React.useRef = function(...args) {
  return originalUseRef.apply(React, args);
};

// Ensure React is globally available
if (typeof window !== 'undefined') {
  window.React = React;
}

export default React;